import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_header = _resolveComponent("skeleton-header")
  const _component_skeleton_wrapper = _resolveComponent("skeleton-wrapper")

  return (_openBlock(), _createBlock(_component_skeleton_wrapper, {
    "has-animation": false,
    class: "gfu-layout-wrapper gfu-layout-wrapper--extranarrow gfu-4of5--l gfu-3of5--xl"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_skeleton_header, { class: "_mb-4" }),
      _createElementVNode("div", {
        class: _normalizeClass($options.skeletonCardsContainerClass)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.cardsCount, (i) => {
          return (_openBlock(), _createBlock(_resolveDynamicComponent($options.skeletonComponent), {
            key: i,
            class: _normalizeClass($options.skeletonCardClass)
          }, null, 8 /* PROPS */, ["class"]))
        }), 128 /* KEYED_FRAGMENT */))
      ], 2 /* CLASS */)
    ]),
    _: 1 /* STABLE */
  }))
}